import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { AXIOS, api_key } from "../../config";
import Loader from "../loader/loader";
import { toast } from "react-toastify";
import { BsCheckSquareFill, BsXSquareFill } from "react-icons/bs";
import { useDispatch } from "react-redux";
import {updatePath} from '../../store/auth/auth'
import './register.css'

export default function RegisterModel({handleClose,show}) {
  const userDetail = useSelector((state: any) => state.register.register);
  const [isLoading, setLoading] = useState<Boolean>(false);

  const pinSchema = Yup.object().shape({
    pin: Yup.string().required("pin is required"),
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: {
      pin: "",
    },
    validationSchema: pinSchema,

    onSubmit: async (values, action) => {
      setLoading(true);
      let newValues = {
        ...userDetail,
        pin: values.pin,
        api_key: api_key,
      };
      // await AXIOS.post(`/register`, newValues)
      console.log('newValues',newValues)
      await AXIOS.post(`/register`, newValues)
        .then((response) => {
          if (response.data.status == "success") {
            toast.success("Successfully Registered");
            dispatch(updatePath('login'))
            navigate("/login");
      handleClose();

          } else {
            toast.error(response.data.showableMessage);
          }
        })
        .catch((error) => {
          console.log(error);
          toast.error("Register Failed", { icon: <BsXSquareFill /> });
        });
      setLoading(false);
      // navigate("/");
      // action.resetForm();
    },
  });
const getCode=async()=>{
  try {
   let code= await AXIOS.post(`/sendMailPin`, {
      api_key: api_key,
      email: userDetail.email,
    })
    console.log('response register',code.data)
    toast.success('pin sent successfully')
  } catch (error) {
    
  }
}
  return (
    <div className="container mt-5 mb-5 reg_verify">
        <div className="row align-items-center">
          <div className="col">
            <div className="verify mb-4">
              <h2>Security Verification</h2>
              <span className="verify_span">
                For your account security, please complete the following
                verification operations
              </span>
            </div>
            <Form onSubmit={formik.handleSubmit}>
              {/* <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Email verification</Form.Label>
              <Form.Control
                type="email"
                placeholder="name@example.com"
                value={
                  userDetail.registerType == "email"
                    ? userDetail.data
                    : userDetail.phone
                }
                autoFocus
                disabled
              />
            </Form.Group> */}
              <Form.Group
                className="mb-3 ver_grp"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label className="verify_lbl">Email Verification Code</Form.Label>
                <Form.Control
                  type="number"
                  placeholder="0000"
                  autoFocus
                  name="pin"
                  value={formik.values.pin}
                  onChange={formik.handleChange}
                />
                <Form.Text>Code will be sent to {userDetail.email}</Form.Text>
                <div className="ver_grp_sp" onClick={getCode}>
                  <span>Get Code</span>
                </div>
              </Form.Group>
              {/* <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Email address</Form.Label>
              <Form.Control
                type="text"
                placeholder="..........."
                autoFocus
                disabled
              />
            </Form.Group>
            <Form.Group
              className="mb-3"
              controlId="exampleForm.ControlTextarea1"
            >
              <Form.Label>Example textarea</Form.Label>
              <Form.Control
                type="number"
                placeholder="Put some text"
                autoFocus
              />
            </Form.Group> */}
              {isLoading == false ? (
                <Button type="submit" className="w-100 fw-bold ver_btn">Submit</Button>
              ) : (
                <Button type="submit" className="w-100 fw-bold ver_btn"> <Loader />
                </Button>
              )}
            </Form>
          </div>
        </div>
      </div>
    // <>
    //   <Modal show={show} onHide={handleClose}>
    //     <Modal.Header closeButton>
    //       <Modal.Title></Modal.Title>
    //     </Modal.Header>
    //     <Modal.Body>
    //       <Form onSubmit={formik.handleSubmit}>
    //         <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
    //           <Form.Label>Email address</Form.Label>
    //           <Form.Control
    //             type="email"
    //             placeholder="name@example.com"
    //             value={
    //               userDetail.registerType == "email"
    //                 ? userDetail.email
    //                 : userDetail.phone
    //             }
    //             autoFocus
    //             disabled
    //           />
    //         </Form.Group>
    //         <Form.Group
    //           className="mb-3"
    //           controlId="exampleForm.ControlTextarea1"
    //         >
    //           <Form.Label>Pin</Form.Label>
    //           <Form.Control
    //             type="number"
    //             placeholder="0000"
    //             autoFocus
    //             name="pin"
    //             value={formik.values.pin}
    //             onChange={formik.handleChange}
    //           />
    //         </Form.Group>
    //         {/* <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
    //           <Form.Label>Email address</Form.Label>
    //           <Form.Control
    //             type="text"
    //             placeholder="..........."
    //             autoFocus
    //             disabled
    //           />
    //         </Form.Group>
    //         <Form.Group
    //           className="mb-3"
    //           controlId="exampleForm.ControlTextarea1"
    //         >
    //           <Form.Label>Example textarea</Form.Label>
    //           <Form.Control
    //             type="number"
    //             placeholder="Put some text"
    //             autoFocus
    //           />
    //         </Form.Group> */}
    //         {isLoading == false ? (
    //           <Button type="submit">Submit</Button>
    //         ) : (
    //           <Loader />
    //         )}
    //       </Form>
    //     </Modal.Body>
    //   </Modal>
    // </>
  );
}
